<template>
  <div class="remind-box">
    <van-popup
      class="van-popup"
      v-model="show"
      close-icon-position="top-right"
      :closeable="false"
      position="bottom"
      :close-on-click-overlay="false"
      :style="{ height: '41%' }"
    >
      <div class="close">
        <span></span>
        <span class="iconfont iconguanbi" @click="getHome"></span>
      </div>
      <div class="title">{{title}}</div>
      <div class="close-content">
        <span>财务在</span>
        <span>{{ verifyTimeCash }}个工作日内</span>
        <span>将进行审核、打款工作，请关注您的账户余额</span>
      </div>
      <div class="btn" @click="getHome">我知道了</div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
      verifyTimeCash: ""
    };
  },
  props: {
    title: String
  },
  methods: {
    getHome() {
      this.$router.push({
        name: "myUserHome"
      });
    }
  },
  mounted() {
    this.verifyTimeCash = this.$store.state.systemConfig.verify_days;
  }
};
</script>

<style lang="less">
.van-popup {
  padding: 15px 15px 20px 15px;
  .close {
    display: flex;
    justify-content: space-between;
  }
  .title {
    font-size: 16px;
    color: #1d1d1d;
    letter-spacing: 0;
  }
  .close-content {
    margin-top: 15px;
    font-size: 14px;
    color: #1d1d1d;
    & span:nth-child(2) {
      color: #ea2c2c;
    }
  }
  .btn {
    background: #8a3e2f;
    width: 100%;
    height: 44px;
    text-align: center;
    color: #ffffff;
    line-height: 44px;
    margin-top: 98px;
  }
}
</style>
